import { ISymbol } from '@aqx-core/common/api/market';
import {
  IFavouriteWatchlistParams,
  IGetWatchlistParams,
  IWatchListUpdateRequest
} from '@aqx-core/common/api/watchlist';
import { request } from '@aqx-core/common/request';

type NewType = IFavouriteWatchlistParams;

export default {
  getWatchlistWithoutMiniChart: (params: IGetWatchlistParams, signal?: AbortSignal) =>
    request.get<ISymbol[]>('/api/market/watchlist/v1', { params, signal }),
  favouriteSymbol: (params: IFavouriteWatchlistParams) => request.post<boolean>('/api/market/watchlist/v1', params),
  unfavouriteSymbol: (params: NewType) => request.delete<boolean>('/api/market/watchlist/v1', { params }),
  pinSymbol: (params: IFavouriteWatchlistParams) =>
    request.put<boolean>(`/api/market/watchlist/v1/pin/${params.symbol}`),
  unpinSymbol: (params: IFavouriteWatchlistParams) =>
    request.delete<boolean>(`/api/market/watchlist/v1/pin/${params.symbol}`),
  updateWatchlistSortOrder: (params: IWatchListUpdateRequest) =>
    request.patch<boolean>('/api/market/watchlist/v1', params),
  getWatchlistWithMiniChart: (params: IGetWatchlistParams) =>
    request.get<ISymbol[]>('/api/market/watchlist/v1/symbols/category', { params })
};
